import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { ANON_FRONTEND } from "../../constants";
import { DateTime } from "luxon";

export default function Redirect({ localStorage }: { localStorage?: Storage }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const mobile = searchParams.get("mobile");
    const web = searchParams.get("web");
    const clinic = searchParams.get("clinic");
    let scheme = "mysherpah";

    if (clinic == "Heartschool") {
        scheme = "heartschool";
    }

    function performRedirect(token: string | null) {
        const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        const Android = /Android/.test(navigator.userAgent);
        let newLocation = "";

        if (token) {
            newLocation = `${ANON_FRONTEND}/try-now/redirect?tryNowToken=${token}&mobile=${mobile}`;
        } else if (iOS) {
            newLocation = scheme + `:${mobile}`;
        } else if (Android) {
            newLocation = scheme + `://${mobile}`;
        } else {
            newLocation = web || "/";
        }

        window.location.replace(newLocation);
    }

    useEffect(() => {
        const storage = localStorage || window.localStorage;
        const token = storage.getItem("tryNowToken");
        const expires = storage.getItem("tryNowTokenExpires");
        if (!token || !expires) {
            performRedirect(null);
            return;
        } else {
            const expiryDate = DateTime.fromISO(expires, { zone: "utc" });
            const now = DateTime.utc();
            performRedirect(expiryDate > now ? token : null);
        }
    }, []);

    return <main className="redirecting">
        <p>Redirecting...</p>
    </main>;
}
